import useOrigin, { OriginContext } from "./useOrigin";
import { useHistory } from "react-router-dom";

export enum PaymentOrigin {
  FUNDING = "FUNDING",
  APPLICATIONS = "APPLICATIONS",
  CREDIT_PROFILE = "CREDIT_PROFILE",
  MONITOR = "MONITOR",
  CRS = "CRS",
  MAPPING_SCREEN = "MAPPING_SCREEN",
}

interface Metadata {
  path?: string;
  id?: number;
}

const redirectOptions = {
  [PaymentOrigin.APPLICATIONS]: {
    title: "Back to funding",
    path: "/business/funding",
  },
  [PaymentOrigin.FUNDING]: {
    title: "Back to application",
    path: "/business/funding/search/[id]/profile",
  },
  [PaymentOrigin.CREDIT_PROFILE]: {
    title: "Back to credit profile",
    path: "/business/credit-profile",
  },
  [PaymentOrigin.MONITOR]: {
    title: "Back to credit checks",
    path: "/business/monitor",
  },
  [PaymentOrigin.CRS]: {
    title: "Back to credit review",
    path: "/business/review",
  },
  [PaymentOrigin.MAPPING_SCREEN]: {
    title: "Back to mapping screen",
    path: "/business/cloud/mapping",
  },
};

function useRedirectTrackingPaymentOrigin(
  defaultOrigin: PaymentOrigin = PaymentOrigin.CREDIT_PROFILE,
  redirectToChangePlan: boolean = false
) {
  const history = useHistory();
  const { origin, metadata, setOrigin, clearOrigin } = useOrigin<
    PaymentOrigin,
    Metadata
  >(OriginContext.PAYMENT);
  const currentOrigin = origin || defaultOrigin;

  const redirectToPaymentFlow = (
    origin: PaymentOrigin,
    metadata?: Record<string, string | number> & { path?: string }
  ) => {
    setOrigin({ value: origin, metadata });
    history.push(
      `/business/${redirectToChangePlan ? "change-plan" : "upgrade"}`
    );
  };

  const redirectToOrigin = (keepOrigin = false) => {
    if (!keepOrigin) {
      clearOrigin();
    }
    if (metadata?.path) {
      return history.push(metadata?.path);
    }
    const redirectInfo = redirectOptions[currentOrigin];
    history.push(redirectInfo.path);
  };

  const info = redirectOptions[currentOrigin];

  return {
    info: { origin: currentOrigin, ...info },
    redirectToPaymentFlow,
    redirectToOrigin,
    clearOrigin,
  };
}

export default useRedirectTrackingPaymentOrigin;
